/**
 * @desc PDA调拨-设置托盘数量
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.allocationMaster.setPlateQty.Params, options?: any) {
  return updateResponse(
    http(URL + `/allocationMaster/setPlateQty`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
